"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultErrorText = exports.getDefaultErrorTitle = exports.getErrorPageTitle = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importDefault(require("react"));
var error_1 = require("../next-api-error/error");
/**
 * Get the page title based on the request status
 * @param response
 */
function getErrorPageTitle(error) {
    if ((0, error_1.isNextApiErrorLike)(error)) {
        if (error.isNotFoundError) {
            return 'Not found';
        }
        if (error.isAuthorizationError) {
            return 'Not allowed';
        }
        if (error.isAuthenticationError) {
            return 'Not logged in';
        }
    }
    return 'Error';
}
exports.getErrorPageTitle = getErrorPageTitle;
/**
 * Get the text for the error message if the quoting plan fails to load.
 */
function getDefaultErrorTitle(error) {
    if (error.isAuthenticationError) {
        return 'Not logged in';
    }
    if (error.isAuthorizationError) {
        return 'Not authorized';
    }
    if (error.isNotFoundError) {
        return 'Not found';
    }
    return error.message;
}
exports.getDefaultErrorTitle = getDefaultErrorTitle;
/**
 * Get the content for the error.
 */
function getDefaultErrorText(error) {
    if (error.isAuthenticationError) {
        return (react_1.default.createElement(core_ui_1.Text, null,
            "You need to be logged in to view this page. ",
            react_1.default.createElement("a", { href: "/login" }, "Login")));
    }
    if (error.isAuthorizationError) {
        return react_1.default.createElement(core_ui_1.Text, null, "You are not authorized to view this page.");
    }
    if (error.isNotFoundError) {
        return react_1.default.createElement(core_ui_1.Text, null, "This page could not be found. Check the URL and try again.");
    }
    return (react_1.default.createElement(core_ui_1.Text, null,
        "There was a problem loading this page. Check the URL and try again. If the problem persists send an email to",
        ' ',
        react_1.default.createElement("a", { href: "mailto:bugs@newfront.com" }, "bugs@newfront.com")));
}
exports.getDefaultErrorText = getDefaultErrorText;
